import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSitemap, faSlash } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-inheritance-info',
    templateUrl: './inheritance-info.component.html',
    styleUrls: ['./inheritance-info.component.scss'],
    imports: [MatTooltipModule, NgClass, FaIconComponent]
})
export class InheritanceInfoComponent implements OnInit, OnChanges {
    public faSitemap = faSitemap;
    public faSlash = faSlash;

    @Input()
    isInherited: boolean;

    @Input()
    parentValue: string;

    @Input()
    id: string;

    public _disabled: boolean;

    public _disabled$: BehaviorSubject<boolean> = new BehaviorSubject(null);

    @Input()
    set disabled(value: boolean) {
        // set the latest value for _data BehaviorSubject
        this._disabled$.next(value);
    }

    parentValueText: string;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['parentValue']) {
            this.parentValueText = `Valeur du groupe / organisation parent(e) : ${this.parentValue}`;
        }
    }

    ngOnInit(): void {
        /**
         * S'abonne aux changements de groupe parents
         */
        this._disabled$.subscribe((x) => {
            this._disabled = x;
        });
    }
}
